import { render, staticRenderFns } from "./QuotationHeader.vue?vue&type=template&id=e1cf2ada&"
import script from "./QuotationHeader.vue?vue&type=script&lang=js&"
export * from "./QuotationHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports